// extracted by mini-css-extract-plugin
export default {"modal":"_32oTjHgM"};